<template>
    <ASelect
        v-model:value="valueState"
        placeholder="Pilih Toko"
        allow-clear
        show-search
        :not-found-content="loading ? undefined : 'Tidak ditemukan'"
        option-filter-prop="label"
        option-label-prop="label"
        @search="onSearch"
        @blur="() => (findText = null)"
        @select="() => (findText = null)"
        v-bind="$attrs"
        :loading="loading"
        :show-arrow="true"
        style="width:300px">
        <ASelectOption v-for="d in lists" :key="d.id" :label="`${d.code} - ${d.name}`">
            <span v-html="highlight(`${d.code} - ${d.name}`)"></span>
        </ASelectOption>
        <template v-if="loading" #notFoundContent>
            <ASpin size="small" />
        </template>
    </ASelect>
</template>

<script>
import { onMounted, ref, watch } from 'vue'
import apiClient from '@/services/axios'
import { useVModel } from '@/components/useVModel.js'
import { debounce, pickBy, isEmpty, values, merge, keyBy } from 'lodash'

export default {
    props: {
        value: {
            type: [Array, Number, Object, String],
            default: null,
        },
        sales_id: {
            type: [Array, Number, String],
            default: null,
        },
        joinOptions: {
            type: [Array],
            default: () => [],
        },
    },
    emits: ['update:value'],
    setup(props, { emit }) {
        const lists = ref([])
        const storage = ref([])
        const findText = ref(null)
        const loading = ref(false)

        const fetchData = () => {
            loading.value = true
            apiClient.get('/api/filter/customer-visit', { params: pickBy({
                q: findText.value,
                sales_id: props.sales_id,
            }) })
                .then(({ data }) => {
                    const options = props.joinOptions.filter(item => item.id !== undefined)
                    if (options.length > 0) {
                        data = values(merge(keyBy(options, 'id'), keyBy(data, 'id')))
                    }

                    lists.value = data.sort((a, b) =>
                        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1,
                    )

                    if (isEmpty(storage.value)) {
                        storage.value = lists.value
                    }

                    // if (!data.find(item => item.id == props.value)) {
                    //     emit('update:value', null)
                    // }
                })
                .finally(() => {
                    loading.value = false
                })
        }

        onMounted(() => {
            fetchData()
        })

        watch(() => props.sales_id, () => {
            fetchData()
        })

        const onSearch = debounce(value => {
            loading.value = true
            findText.value = value
            fetchData()
        }, 300)

        const highlight = value => {
            return value.replace(new RegExp(findText.value, 'gi'), match => {
                return `<span style="background-color: yellow;">${match}</span>`
            })
        }

        return {
            lists,
            valueState: useVModel(props, 'value'),
            findText,
            highlight,
            onSearch,
            loading,
        }
    },
}
</script>